:host {
  display: block;
}

.input-rounded-button {
  font-family: var(--typography-font-input-rounded-button);
}

.input-rounded-button__container {
  @apply flex border border-solid;
  @apply pl-5 pr-10 py-3;
  @apply transition-colors duration-300;
  border-radius: var(--border-radius-input-rounded-button);
  color: var(--clrs-text-input-rounded-button);
}

.input-rounded-button__container--with-caption {
  @apply pt-2 pb-1;
}

.input-rounded-button__container--unselected-enabled {
  @apply cursor-pointer;
  background-color: var(--clrs-bg-input-rounded-button-unselected);
  border-color: var(--clrs-border-input-rounded-button-unselected-enabled);
}

.input-rounded-button__container--selected-enabled {
  @apply cursor-pointer;
  background-color: var(--clrs-bg-input-rounded-button-selected);
  border-color: var(--clrs-input-rounded-button-selected);
}

.input-rounded-button__container--unselected-disabled {
  @apply pointer-events-none;
  background-color: var(--clrs-bg-input-rounded-button-unselected);
  border-color: var(--clrs-border-input-rounded-button-unselected-disabled);
}

.input-rounded-button__container--selected-disabled {
  @apply pointer-events-none;
  background-color: var(--clrs-bg-input-rounded-button-selected);
  border-color: var(--clrs-input-rounded-button-selected);
}

.input-rounded-button__container--unselected-locked {
  @apply pointer-events-none min-w-14 border-none;
  background-color: var(--clrs-bg-input-rounded-button-unselected-locked);
  color: var(--clrs-text-input-rounded-button-unselected-locked);
}

.input-rounded-button__container--selected-locked {
  @apply pointer-events-none min-w-14 border-none;
  background-color: var(--clrs-bg-input-rounded-button-selected-locked);
  color: var(--clrs-text-input-rounded-button-selected-locked);
}

.input-rounded-button__container--error {
  @apply border-clrs-red text-clrs-red;
  border-color: var(--clrs-input-rounded-button-error);
  color: var(--clrs-input-rounded-button-error);
}

.input-rounded-button__overlay {
  @apply transition ease-in-out duration-200 box-border absolute top-[1px] left-[1px] w-5 h-5 rounded-full;
}

.input-rounded-button__overlay--enabled {
  @apply group-hover:shadow-radio;
}

.input-rounded-button__radio {
  @apply relative bg-white w-5 h-5 rounded-full border-solid border border-clrs-neutral-true-grey transition-colors duration-300;
  @apply after:content-[''] after:block after:absolute after:w-4 after:rounded-full after:h-4 after:left-[2px] after:bottom-[2px] after:transition-colors;
}

.input-rounded-button__radio--selected:after {
  background-color: var(--clrs-input-rounded-button-selected);
}

.input-rounded-button__radio--disabled {
  @apply opacity-50;
  background-color: var(--clrs-bg-radio-input-rounded-button-unselected-disabled);
}

.input-rounded-button__label-wrapper {
  @apply relative leading-6 text-sm;
}

.input-rounded-button__label-wrapper--disabled {
  @apply opacity-50;
}

.input-rounded-button__lock-icon {
  @apply w-5;
  color: var(--clrs-input-rounded-button-selected-locked);
}
